import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const http = client;
export default client;

export const fmt = {
    money(n) {
        if (n === null || n === undefined) return "$0";
        return "$" + Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 });
    },
    moneyFull(n) {
        if (n === null || n === undefined) return "$0.00";
        return "$" + Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    date(iso) {
        if (!iso) return "—";
        try { return new Date(iso).toLocaleString(); } catch { return iso; }
    },
};
